"use strict";
/**
 * Domain helpers for the Metrics admin view (kept separate from the
 * generic `metrics-utils.ts` clone/equality helpers).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueUseCaseCount = void 0;
/**
 * Returns the number of distinct use cases that contribute at least one
 * raw signal to the given metric group. Used by the group card chip to
 * answer "in how many use cases is this group present?" without
 * double-counting use cases that supply multiple signals.
 */
exports.getUniqueUseCaseCount = function (category) {
    var ids = {};
    category.properties.forEach(function (property) {
        property.useCases.forEach(function (useCase) {
            ids[useCase.id] = true;
        });
    });
    return Object.keys(ids).length;
};
